import { z } from 'zod';

const QueryField = z.array(z.string().uuid().array()).nullish();

export const QueryStoreQueryModel = z.object({
  policyIds: QueryField,
  organizationIds: QueryField,
  relatedOrganizationIds: QueryField,
  expenditurePurposeIds: QueryField,
  expenditureBudgetPurposeIds: QueryField,
  expenditureNatureIds: QueryField,
  expenditureItemNatureIds: QueryField,
  otherResponsibleOrganizationIds: QueryField,
  pinpointKeys: z.array(z.string().array()).nullish(),
});

const QueryLeafsField = z.array(z.string().uuid()).nullish();

export const QueryStoreQueryLeafsModel = z.object({
  policyIds: QueryLeafsField,
  organizationIds: QueryLeafsField,
  relatedOrganizationIds: QueryLeafsField,
  expenditurePurposeIds: QueryLeafsField,
  expenditureBudgetPurposeIds: QueryLeafsField,
  expenditureNatureIds: QueryLeafsField,
  expenditureItemNatureIds: QueryLeafsField,
  otherResponsibleOrganizationIds: QueryLeafsField,
  // /** 箇所指定 */
  pinpointKeys: z.array(z.string()).nullish(),
});

export const QueryStoreModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  query: QueryStoreQueryModel.nullish(),
  queryLeafs: QueryStoreQueryLeafsModel.nullish(),
});
